<template>
  <div class="embed">
      <div class="emForm">
          <h1>Stay updated!</h1>
           <h3>I share GIFs weekly on social media, so follow to stay updated!</h3>
           <Sendy/>
      </div>
      <div class="emSocials">
          <section class="ss-icon">
            <a class="iconEmbed"  target="_blank" href="https://discordapp.com/invite/halfhumangames"><article><span><i class="fab fa-discord fa-2x"></i></span></article></a>
             <a class="iconEmbed"  target="_blank" href="https://twitter.com/HalfHumanGames/"><article><span>twitter</span></article></a> 
            <a class="iconEmbed"   target="_blank" href="https://www.facebook.com/HalfHumanGames/"><article><span>facebook</span></article></a>
          
            
            <a class="iconEmbed"  target="_blank" href="https://www.instagram.com/halfhumangames/"><article><span>instagram</span></article></a>
            <a class="iconEmbed"  target="_blank" href="https://www.reddit.com/r/halfhumangames/"><article><span><i class="fab fa-reddit fa-2x"></i></span></article></a>
            <a class="iconEmbed" target="_blank"  href="https://www.youtube.com/channel/UCT6Iqrqj8ZmolRj1yDBN3EQ"><article><span>youtube</span></article></a>

          </section>
      </div>
     
  </div>
</template>

<script>
import Sendy from "@/views/Home/Sendy.vue";
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: ""
    };
  } ,
  components: {
      Sendy
  },
  mounted(){
      document.querySelector("nav.navbar").style.visibility = "hidden";
      document.querySelector(".sendySubmit input#submit").style.width = "116px";
      document.querySelector(".sendySubmit input#submit").style.height = "43px";
      document.querySelector(".embed input#email").style.width = "100%";
      document.querySelector(".embed input#email").style.marginTop = "10px";
      document.querySelector(".embed .sendySubmit").style.marginTop = "15px"
      document.querySelector(".page-loader").style.background = "transparent";
      document.querySelector("body").style.background = "url(https://dwerve.com/static/assets/images/Dwerve-Brick-Texture.png)";
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto:700,500");
@import url("https://fonts.googleapis.com/css?family=Montserrat:700,500,400,500,200");
.emForm h1 {
    color: #fff;
    text-transform: uppercase;
    font-family: Roboto;
      margin-top: 25px;
      font-size: 25px;
}
.embed .emForm h3 {
  color: #fff;
    font-family: Montserrat;
    font-weight: 400;
   font-size: 16px;
    line-height: 1.6;
        margin-top: 2px;
    margin-bottom: 0;
}
section {
width: 420px;
  min-height: 270px;
  font-size: 35px;
  text-align: center;
}
i.fab {
    font-size: 36px;
}
a.iconEmbed {
  display: inline-block;
  position: relative;
  float: left;
    width: 90px;
    height: 90px;
    margin: 5px;
}

article {
  cursor: pointer;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #333;
  box-shadow: 0 0 6px -2px #000, 0 0 45px -20px #000;
  color: #fff;
 line-height: 98px;
  transform: perspective(300px) rotateY(0deg);
  transition: transform 0.4s linear, background-color 0s linear 0.2s, color 0s linear 0.2s;
}
a:hover article {
  transform: perspective(300px) rotateY(180deg);
  color: #eee;
  transition: transform 0.2s linear, background-color 0s linear 0.1s, color 0s linear 0.1s;
}
a:nth-child(1):hover article {
  background-color: #6f82e1;
}
a:nth-child(2):hover article {
  background-color: #00ACED;
}
a:nth-child(3):hover article {
  background-color: #3B5998;
}
a:nth-child(4):hover article {
  background-color: #3F729B;
}
a:nth-child(5):hover article {
  background-color: #df3500;
}
a:nth-child(6):hover article {
  background-color: #cb2027;
}
a:nth-child(7):hover article {
  background-color: #3399CC;
}
a:nth-child(8):hover article {
  background-color: #EA4C89;
}
a:nth-child(9):hover article {
  background-color: #3F729B;
}
a:nth-child(10):hover article {
  background-color: #FF0084;
}
a:nth-child(11):hover article {
  background-color: #F26300;
}
a:nth-child(12):hover article {
  background-color: #445566;
}

span {
  transition: transform 0s linear 0.2s, text-shadow 0s linear 0.2s;
  display: block;
  -webkit-font-smoothing: subpixel-antialiased;
  font-smoothing: antialiased;
}
a:hover span {
  transition: transform 0s linear 0.1s, text-shadow 0s linear 0.1s;
  transform: scale(-1, 1);
  text-shadow: 0 0 50px rgba(255, 255, 255, 0.5);
}


@font-face {
  font-family: "SSSocial";
  src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/2361/ss-social-regular.eot");
  src: url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/2361/ss-social-regular.eot?#iefix") format("embedded-opentype"), url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/2361/ss-social-regular.woff") format("woff"), url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/2361/ss-social-regular.ttf") format("truetype"), url("https://s3-us-west-2.amazonaws.com/s.cdpn.io/2361/ss-social-regular.svg#SSSocialRegular") format("svg");
  font-weight: normal;
  font-style: normal;
}
/* This triggers a redraw in IE to Fix IE8's :before content rendering. */
html:hover [class^="ss-"] {
  -ms-zoom: 1;
}

.ss-icon, .ss-icon.ss-social, .ss-icon.ss-social-circle,
[class^="ss-"]:before, [class*=" ss-"]:before,
[class^="ss-"][class*=" ss-social"]:before, [class*=" ss-"][class*=" ss-social"]:before,
[class^="ss-"].right:after, [class*=" ss-"].right:after,
[class^="ss-"][class*=" ss-social"].right:after, [class*=" ss-"][class*=" ss-social"].right:after {
  font-family: "SSSocial";
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  text-rendering: optimizeLegibility;
  white-space: nowrap;
  -moz-font-feature-settings: "liga=1";
  -moz-font-feature-settings: "liga";
  -ms-font-feature-settings: "liga" 1;
  -o-font-feature-settings: "liga";
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}

.ss-icon.ss-social-circle,
[class^="ss-"].ss-social-circle:before, [class*=" ss-"].ss-social-circle:before,
[class^="ss-"].ss-social-circle.right:after, [class*=" ss-"].ss-social-circle.right:after {
  font-weight: bold;
}

[class^="ss-"].right:before,
[class*=" ss-"].right:before {
  display: none;
  content: '';
}
.embed {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
      max-width: 700px;
    margin: auto;
        background: #6b92ad;
    padding: 20px;
       margin: auto;
    border-radius: 5px;
    background: transparent;
    box-shadow: 0 0 6px -2px #000, 0 0 45px -20px #000;
    padding: 20px;
}
.embed .emForm {
    width: 100%;
    padding-right: 20px;
    max-width: 352px;
}
.emSocials {
    flex-grow: 1;
    display: flex;
    justify-content: center;
}
section.ss-icon {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 303px;
    justify-content: center;
    align-content: flex-start;
}
.sendySubmit input#submit {
    width: 112px;
    height: auto;
}

@media(max-width:699px) {
  section.ss-icon{
      justify-content: space-around;
      max-width: 441px;
        align-content: flex-start;
  }
    a.iconEmbed{
          width: 30px;
        height: 30px;
        position: relative;
        top: -7px;
    }
    .embed .emForm{
        max-width: 410px;
    }
    article{
      line-height: 2;
      background: transparent;
    }
    .embed{
      padding: 12px;
    }
    a:hover article {
      background-color: transparent !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/embedWidget.vue